var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnFlowchartLink = function SvgIcnFlowchartLink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_597_229770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 14L14 10",
    stroke: "#3D41CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 8.00004L11.6422 7.64271C12.2674 7.01759 13.1153 6.66644 13.9994 6.6665C14.8835 6.66657 15.7314 7.01784 16.3565 7.64304C16.9816 8.26824 17.3328 9.11617 17.3327 10.0003C17.3326 10.8844 16.9814 11.7323 16.3562 12.3574L16.0002 12.6667",
    stroke: "#3D41CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 16L12.4019 16.356C11.7694 16.9815 10.9158 17.3323 10.0263 17.3323C9.13674 17.3323 8.2831 16.9815 7.6506 16.356C7.33884 16.0478 7.09133 15.6807 6.92241 15.2761C6.75348 14.8716 6.6665 14.4375 6.6665 13.999C6.6665 13.5606 6.75348 13.1265 6.92241 12.7219C7.09133 12.3174 7.33884 11.9503 7.6506 11.642L7.99993 11.3334",
    stroke: "#3D41CD",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_597_229770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnFlowchartLink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_flowchart_link.bd47bc07.svg";
export { ForwardRef as ReactComponent };